import React, { useMemo } from 'react'
import { makeStyles } from '@mui/styles'
import { useAppSelector } from '@/redux/store'
import { orderBy } from 'lodash'
import moment from 'moment'

import { user } from 'ampersand-app'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import lang from '@/lang'
import ThemeInterface from '@/theme-interface'
import ShoppingCartIcon from '@assets/images/icons/shopping-cart.svg'
import { ProductTypes } from '@/modules/base/util/constants'
import FloatingBadge, { Varients } from '@/modules/base/components/badge/floating-badge'
import { useUpgradeModal } from '@/hooks/useUpgradeModal'
import navigateToShop from '@/modules/moduleSubscription/components/_helpers/navigateToShop'
import { isMeinBuero } from '@/utils/build-env'
import GtmService, { GtmEventTypes } from '@/modules/_services/gtm.service'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  root: {
    padding: '0 10px',
    cursor: 'pointer',
  },
  label: {
    fontSize: theme.fontSizes.smaller,
    lineHeight: theme.fontSizes.smaller,
    marginLeft: 5,
  },
}), { name: 'UpgradeNotch' })

const SUBSCRIPTIONS_WITH_DISCOUNT = [ProductTypes.MAIN, ProductTypes.DOCUMENT, ProductTypes.STAFF]

const UpgradeNotch = () => {
  const classes = useStyles()
  const openUpgradeModal = useUpgradeModal()
  const { subscriptions, loading: isLoading } = useAppSelector(state => state.subscription.details)
  const tenantRestores = useAppSelector(state => state.tenant.info.restores)
  const { end: subscriptionEnd } = orderBy(subscriptions, ['end'], ['desc'])[0] || {}
  const remainingDays = subscriptionEnd ? Math.max(moment(subscriptionEnd).diff(moment(), 'days'), 0) : null
  const isTrial = (!user.isDemo && !user.subscriptions?.some(s => s.isTrial === false))
  const isSubscriptionWithDiscount = subscriptions.some(s => SUBSCRIPTIONS_WITH_DISCOUNT.includes(s.typeOfSubscription))

  const notchLabel = useMemo(() => {
    if (isTrial) {
      return remainingDays > 0
        ? isSubscriptionWithDiscount
          ? lang.footer.trialWithDiscountText(remainingDays)
          : lang.footer.trialText(remainingDays)
        : lang.footer.trialExpiredText
    } else if (remainingDays < 15) return remainingDays > 0 ? lang.footer.subscriptionText(remainingDays) : lang.footer.subscriptionExpired
  }, [remainingDays, isTrial, isLoading])

  const onUpgrade = () => {
    if (isMeinBuero()) {
      GtmService.pushEvent({
        event: GtmEventTypes.MboOnboarding,
        'mbo-onboarding-step': 'buchen',
      })
      navigateToShop({ selectActiveTrialProduct: true, scrollIntoPlans: true })
    } else {
      GtmService.pushEvent({
        event: GtmEventTypes.GaEventHub,
        eventCategory: 'tester-zu-kauf_funnel',
        eventAction: 'click_testphase',
        eventLabel: 'testphase_beenden_badge',
      })
      openUpgradeModal()
    }

  }

  if (!subscriptions?.length || isLoading || user.isDemo || subscriptions?.some(s => s.isTrial === false)
    || (isMeinBuero() && tenantRestores?.length > 0)
  ) {
    return null
  }

  return (
    <FloatingBadge varient={Varients.DANGER} className={classes.root} onClick={onUpgrade}>
      <SVGIcon svg={ShoppingCartIcon} height='15px' width='15px' fill='white' />
      <span className={classes.label}>{notchLabel}</span>
    </FloatingBadge>
  )
}

export default UpgradeNotch
